// extracted by mini-css-extract-plugin
module.exports = {"root":"Product_root__9_Zq3","content":"Product_content__w6MRE","title":"Product_title__lMY4Y","subtitle":"Product_subtitle__cKT0i","advantage":"Product_advantage__esfMb"};